<wiz-h-divider width="100%" height="100%" gap="0" padding="5px">
  <!-- panneau gauche -->
  <wiz-vgroup width="350px" minWidth="0px" maxWidth="400px" height="100%">
    <multi-display #multiDisp width="100%" height="100%" [config]="multiDisplayConfig">
      <wiz-hgroup target="icons">
        <wiz-icon #btnExport [wizTooltip]="'$.common.export.$'" class="image-purple"
          (click)="doAct('export')">download</wiz-icon>
        <wiz-icon #btnImport [wizTooltip]="'$.common.import.$'" class="image-purple"
          (click)="doAct('import')">upload</wiz-icon>
        <wiz-icon #btnRemove class="image-purple" [wizTooltip]="'$.common.delete.$'"
          (click)="doAct('delete')">delete</wiz-icon>
      </wiz-hgroup>

      <wiz-vgroup target="title">
        <wiz-hgroup verticalAlign="center" gap="10" padding="0 0 10px">
          <wiz-icon #btnAddWg [wizTooltip]="'$.wg.add.$'" tooltipPlacement="right" class="image-back-orange"
            (click)="doAct('create')">add</wiz-icon>
          <wiz-label class="titleLabel" [wizLabel]="'$.wg.add.$'" [wizTextBehavior]="'truncate'"
            width="100%"></wiz-label>
        </wiz-hgroup>
      </wiz-vgroup>

    </multi-display>

  </wiz-vgroup>

  <!-- zone détail -->
  <wiz-group width="100%" height="100%" class="section-container-parent">
    <!-- lorsque rien n'est sélectionné -->
    <widget-renderer *ngIf="!isDetailVisible" class="view-widget" width="100%" [title]="'$.wg.home.title.$'"
      [description]="'$.wg.home.description.$'"></widget-renderer>

    <!-- zone détail -->
    <wiz-vgroup wizValidationContainer #vgDetailZone [visible]="isDetailVisible" width="100%" height="100%">
      <!-- header -->
      <wiz-hgroup wizValidationContainer padding="5px" width="100%" class="section-container" verticalAlign="center"
        horizontalAlign="space-between">
        <!-- champs de saisie -->
        <wiz-hgroup [verticalAlign]="'center'" gap="20">
          <wiz-text-input #tiCode class="upper-case-input" width="205px" [wizLabel]="'$.common.code.$'"
            [wizValidator]="uniqueCodeValidator()" [wizShowErrors]="true" [wizMandatory]="true" [wizMaxChars]="50"
            [wizPlaceholder]="'$.common.define.$'"></wiz-text-input>
          <wiz-translation #tiLabelTrs width="205px" [wizLabel]="'$.common.label.$'" [wizMandatory]="true"
            [wizPlaceholder]="'$.common.define.$'" [wizMaxChars]="100" [wizShowErrors]="true"></wiz-translation>
        </wiz-hgroup>

        <!-- boutons d'action -->
        <wiz-vgroup width="200px" height="100%" horizontalAlign="center" verticalAlign="end">
          <wiz-button #btnSave [wizIcon]="'arrow-right'" [wizLabel]="'$.common.save.modification.$'"
            [iconPlacement]="'right'" [wizDisabled]="disableButtons()"></wiz-button>
          <wiz-button #btnCancel class="cancel-button" [wizIcon]="'arrow-left'"
            [wizLabel]="'$.common.cancel.modification.$'" [wizDisabled]="disableCancel()"></wiz-button>
        </wiz-vgroup>
      </wiz-hgroup><!-- fin de la section détail -->

    </wiz-vgroup>
  </wiz-group>
</wiz-h-divider>